import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Video } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useProject } from '@/lib/project-context'
import { Button } from '@/components/ui/button'

/**
 * PLAN-085: the `/meet/$code` route stays registered (calendar invites carry
 * the link) but renders a "not enabled" page when the organization has the
 * `realtimeMeetings` flag off — same idiom as the inbox gate. The server
 * refuses the procedures and the room socket as well.
 */
export function MeetFeatureGate({
  projectId,
  children,
}: {
  projectId: string
  children: ReactNode
}) {
  const { t } = useTranslation('meet')
  const { project } = useProject()
  if (project.features.realtimeMeetings) return <>{children}</>
  return (
    <div className="flex h-full flex-1 items-center justify-center p-10">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <Video className="text-muted-foreground/60 h-8 w-8" />
        <h1 className="text-lg font-semibold">{t('disabled.title')}</h1>
        <p className="text-muted-foreground text-sm">{t('disabled.description')}</p>
        <Button asChild variant="outline" size="sm" className="mt-2">
          <Link to="/$projectId" params={{ projectId }}>
            {t('disabled.back')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
